export * from './error/error.component';
export * from './error/error.route';
export * from './main/main.component';
export * from './header/header.component';
export * from './header/header.route';
export * from './footer/footer.component';
export * from './footer/footer.route';
export * from './profiles/page-ribbon.component';
export * from './profiles/profile.service';
export * from './profiles/profile-info.model';
export * from './layout.route';
export * from './layout-routing.module';





// WEBPACK FOOTER //
// ./src/app/layouts/index.ts